import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import DatasetIcon from "@mui/icons-material/Storage";
import TimelineIcon from "@mui/icons-material/Timeline";

export default function ViewActivityDialog({ open, onClose, order }) {
  const datasets = order?.notes?.viewed_datasets || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TimelineIcon color="primary" />
        <span>Datasets Viewed Before Purchase</span>
      </DialogTitle>

      <DialogContent dividers>
        {datasets.length === 0 ? (
          <Typography color="text.secondary" align="center" sx={{ py: 3 }}>
            No dataset activity recorded for this order.
          </Typography>
        ) : (
          <>
            <Box mb={1}>
              <Typography variant="body2" color="text.secondary">
                Customer: <strong>{order.name || order.email}</strong>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Order #{order.id} &middot;{" "}
                {new Date(order.createdAt).toLocaleDateString()}
              </Typography>
            </Box>

            <Chip
              label={`${datasets.length} dataset${datasets.length > 1 ? "s" : ""} viewed`}
              size="small"
              color="primary"
              variant="outlined"
              sx={{ mb: 2 }}
            />

            <List dense disablePadding>
              {datasets.map((ds, idx) => (
                <ListItem
                  key={ds.id || idx}
                  sx={{
                    borderRadius: 1,
                    mb: 0.5,
                    bgcolor: "grey.50",
                    border: "1px solid",
                    borderColor: "grey.200",
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <DatasetIcon fontSize="small" color="action" />
                  </ListItemIcon>
                  <ListItemText
                    primary={ds.name || `Dataset ${ds.id}`}
                    secondary={
                      <>
                        ID: {ds.id}
                        {ds.ts && (
                          <>
                            &middot;
                            {ds?.action === "added-to-cart"
                              ? "Added to Cart"
                              : "Viewed"}
                            : {new Date(ds.ts).toLocaleString()}
                          </>
                        )}
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
